// Meta's Conversions API event names, offered as a pre-populated dropdown when mapping a
// label to a conversion event (see ConversionsConfigurationPage.vue). Labels backend-side
// accept any string (Inbox#conversion_api_config['label_event_mapping']) — this list is a
// frontend convenience, not an enforced backend enum.
//
// IMPORTANT: unlike the web Pixel, the Conversions API rejects any event_name other than
// these two when action_source is "business_messaging" (WhatsApp/CTWA — see
// MetaConversions::SendEventService). Sending e.g. 'Contact' or 'CompleteRegistration'
// here gets a 400 from Meta (error_subcode 2804066) on every attempt. Do not add the
// generic Pixel standard events (Lead, Schedule, InitiateCheckout, etc.) back to this list.
export const META_STANDARD_EVENTS = ['LeadSubmitted', 'Purchase'];

export const CUSTOM_EVENT_VALUE = '__custom__';
export const DONT_SEND_VALUE = '';
